


















import { mapGetters, mapState } from 'vuex'
import { USER_NS } from '~/store/modules/shared/user/state'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import {
  defineComponent,
  defineVue3AsyncComponent
} from '~/utils/nuxt3-migration'
import SellerInfoGuestAnonymous from '~/components/car/classifieds/view/partials/seller/guest-anon/SellerInfoGuestAnonymous.vue'
import SellerInfoDealer from '~/components/car/classifieds/view/partials/seller/dealer/SellerInfoDealer.vue'
import VerifiedUser from '~/components/car/classifieds/view/partials/VerifiedUser.vue'

export default defineComponent({
  components: {
    SellerInfoGuestAnonymous,
    SellerInfoDealer,
    CCard,
    VerifiedUser,
    UserEditAdminButton: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/seller/UserEditAdminButton.vue'
      )
    )
  },
  props: {
    seller: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      classifiedId: state => state.classified.id,
      classified: state => state.classified
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    sellerIsVerified(): Boolean {
      return this.seller?.verification?.creditCardVerified || false
    },
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      sellerIsAgent: 'sellerIsAgent',
      sellerIsNonPublicDealer: 'sellerIsNonPublicDealer',
      sellerIsOfTypeDealer: 'sellerIsOfTypeDealer',
      isJobsClassified: 'isJobsClassified',
      sellerIsConstructionCompany: 'sellerIsConstructionCompany'
    }),
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin'
    }),
    sellerTitle() {
      if (this.sellerIsConstructionCompany) {
        return this.$t('construction company')
      } else if (this.sellerIsAgent) {
        return this.$t('agent')
      } else if (this.sellerIsOfTypeDealer) {
        return this.$t('dealer')
      } else if (this.sellerIsNonPublicDealer) {
        return this.$t('registered user')
      } else if (this.isJobsClassified) {
        // hiding the "private" label for jobs classifieds since many of the created classifieds will be from privates
        return this.$t('contact info')
      } else {
        return this.$t('private::seller_type')
      }
    }
  }
})
